// The lazily loaded window scripts (/js/addressModal.js, /js/deleteDialog.js ...) with the version of the build
// (mix-manifest.json `?id=`), like the engine's own app.js: the server sends them with a one year max-age, so an
// unversioned URL keeps running the file the browser cached first, whatever is deployed later.
let manifest = null;
const pending = {};

const versioned = (path) => {
    if (!manifest) {
        manifest = fetch('/mix-manifest.json', { headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : {}))
            .catch(() => ({}));
    }
    return manifest.then((m) => m[path] || path);
};

/** Loads /js/{name}.js once (a failed manifest falls back to the plain URL); resolves when the script is in. */
export default function loadModuleScript(name) {
    if (!pending[name]) {
        pending[name] = versioned(`/js/${name}.js`).then((src) => new Promise((resolve, reject) => {
            const tag = document.createElement('script');
            tag.src = src;
            tag.onload = resolve;
            tag.onerror = () => { delete pending[name]; reject(new Error(`${name} script failed to load`)); };
            document.getElementsByTagName('body')[0].appendChild(tag);
        }));
    }
    return pending[name];
}
